import React from "react";
import { getCardImageUrl } from "../../utils/GetImageUrl";
import RoundTripCard from "../cards/roundTripCard";
import { RoundTripFlightMatch } from "../../models/RoundTripFlightMatch";

interface Props {
  flightList: RoundTripFlightMatch[];
}

const RoundTripCardList: React.FC<Props> = ({ flightList }) => {
  if (!flightList || flightList.length === 0) return null;

  return (
    <div className="flex justify-start items-start gap-6 flex-wrap">
      {flightList.slice(0, 4).map((flight, index) => {
        const destinationIata = flight.round_trip_flight.outbound_flight.destination_iata;
        return (
          <RoundTripCard
            key={index}
            roundTripFlightMatch={flight}
            imageUrl={getCardImageUrl(destinationIata)}
          />
        );
      })}
    </div>
  );
};

export default RoundTripCardList;
